import UaDictSection from "./components/UaDictSection";

const UaRuLtPage: React.FC = () => {
  return (
    <div>
      <p>
        Credits and complaints to Vytautas Miežys{" "}
        <a href="https://www.facebook.com/frombilas.bombilas">(FB here)</a>
      </p>
      <UaDictSection />
    </div>
  );
};

export default UaRuLtPage;
